import React from 'react';
import { useNavigate } from 'react-router-dom';

const SECTIONS = [
  {
    icon: '🔐',
    title: 'Data Protection',
    body: 'Your personal data is encrypted and stored securely. We never share your information with third parties without your consent.',
  },
  {
    icon: '💳',
    title: 'Payment Security',
    body: 'All transactions are processed through secure, encrypted channels. We never store your full payment details on our servers.',
  },
  {
    icon: '🛡️',
    title: 'Account Security',
    body: 'Your password is hashed using industry-standard encryption. We recommend using a strong, unique password.',
  },
  {
    icon: '💬',
    title: 'Communication Privacy',
    body: 'Messages between you and other users are private. We do not read or monitor your conversations.',
  },
  {
    icon: '🗑️',
    title: 'Data Deletion',
    body: 'You can delete your account and all associated data at any time from your Account settings. This action is permanent and cannot be undone.',
  },
];

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-dark-bg pb-24">
      {/* Header */}
      <div className="px-4 pt-12 pb-4 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="text-dark-subtext">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <h1 className="text-xl font-bold text-dark-text" style={{ letterSpacing: '-0.5px' }}>Privacy &amp; Security</h1>
      </div>

      <div className="px-4 space-y-3">
        {SECTIONS.map((section, i) => (
          <div key={i} className="bg-dark-surface border border-dark-border rounded-2xl p-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-2xl bg-dark-bg flex items-center justify-center text-lg flex-shrink-0">
                {section.icon}
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-sm font-bold text-dark-text mb-1">{section.title}</h2>
                <p className="text-dark-subtext text-sm leading-relaxed">{section.body}</p>
              </div>
            </div>
          </div>
        ))}

        {/* Terms link */}
        <div className="bg-dark-surface border border-dark-border rounded-2xl p-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-2xl bg-dark-bg flex items-center justify-center text-lg flex-shrink-0">
              📄
            </div>
            <div>
              <p className="text-sm font-bold text-dark-text">Terms of Service</p>
              <p className="text-dark-subtext text-xs mt-0.5">Read our full terms and conditions</p>
            </div>
          </div>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-dark-subtext flex-shrink-0">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </div>

        {/* Last updated */}
        <p className="text-dark-subtext/60 text-xs text-center pt-2">Last updated: March 2026</p>
      </div>
    </div>
  );
}
